import { Injectable } from '@angular/core';
import { IWorkDebtors } from '@interfaces/IWorkDebtors';
import { IAppState } from '@myStore/app.state';
import {
  AddWorkDebtorsFailure,
  AddWorkDebtorsRequest,
  AddWorkDebtorsSuccess,
  EWorkDebtorsActions,
  GetWorkDebtorsByGroupFailure,
  GetWorkDebtorsByGroupRequest,
  GetWorkDebtorsByGroupSuccess,
  GetWorkDebtorsFailure,
  GetWorkDebtorsRequest,
  GetWorkDebtorsSuccess,
} from '@myStore/work-debtors/work-debtors.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { WorkDebtorsService } from '@services/work-debtors/work-debtors.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class WorkDebtorsEffects {
  constructor(
    private _actions$: Actions,
    private _store: Store<IAppState>,
    private _toastr: ToastrService,
    private _workDebtorsService: WorkDebtorsService
  ) {}

  get$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetWorkDebtorsRequest>(
          EWorkDebtorsActions.GetWorkDebtorsRequest
        ),
        switchMap(action => {
          return this._workDebtorsService.get(action.qParams).pipe(
            map(res => {
              this._store.dispatch(new GetWorkDebtorsSuccess(res));
            }),
            catchError(err => {
              this._toastr.error(
                `${
                  err?.error?.detail
                    ? err?.error?.detail
                    : 'При получении работ должников возникла ошибка'
                }`,
                'Что-то пошло не так',
                { timeOut: 3500 }
              );
              this._store.dispatch(new GetWorkDebtorsFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  getByGroup$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetWorkDebtorsByGroupRequest>(
          EWorkDebtorsActions.GetWorkDebtorsByGroupRequest
        ),
        switchMap(action => {
          return this._workDebtorsService
            .getByGroup(action.groupId, action.qParams)
            .pipe(
              map((res: IWorkDebtors) => {
                this._store.dispatch(new GetWorkDebtorsByGroupSuccess(res));
              }),
              catchError(err => {
                this._toastr.error(
                  `${
                    err?.error?.detail
                      ? err?.error?.detail
                      : 'При получении работ должников группы возникла ошибка'
                  }`,
                  'Что-то пошло не так',
                  { timeOut: 3500 }
                );
                this._store.dispatch(
                  new GetWorkDebtorsByGroupFailure(err.error)
                );
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  post$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<AddWorkDebtorsRequest>(
          EWorkDebtorsActions.AddWorkDebtorsRequest
        ),
        switchMap(action => {
          return this._workDebtorsService.post(action.data).pipe(
            map(() => {
              this._store.dispatch(new AddWorkDebtorsSuccess());
            }),
            catchError(err => {
              this._toastr.error(
                `${
                  err?.error?.detail
                    ? err?.error?.detail
                    : 'При добавлении работ должников возникла ошибка'
                }`,
                'Что-то пошло не так',
                { timeOut: 3500 }
              );
              this._store.dispatch(new AddWorkDebtorsFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );
}
